import MultiStepLayout from "./MultiStepLayout";
import SimpleInput from "./SimpleInput";
import Dropdown from "./Dropdown";
import Group from "./RadioGroup";
import Button from "./Button";
import HeightPicker from "./HeightPicker";
import PoweredBy from "../components/PoweredBy";
import { useTranslation } from "react-i18next";
import { ONE_MONTH, THREE_MONTHS, SIX_MONTHS, YEAR } from "../utilities/constants";

function Step2({
  leadForm,
  lead,
  onChange,
  onBlur,
  step2Valid,
  submitStep2,
  submitting,
  useMetricSystem,
  isMobile,
  activeElement,
  setActiveElement,
}) {
  const required = leadForm.questions === "Required";
  const { t } = useTranslation();

  const bodyClick = (e) => {
    if (e.target.nodeName === "DIV" && !e.target.closest(".group")) {
      setActiveElement(null);
    }
  }

  const additionalQuestions = [
    { label: t("lead.additionalInformation.oneMonth"), value: ONE_MONTH },
    { label: t("lead.additionalInformation.threeMonth"), value: THREE_MONTHS },
    { label: t("lead.additionalInformation.sixMonth"), value: SIX_MONTHS },
    { label: t("lead.additionalInformation.year"), value: YEAR },
  ]

  return (
    <MultiStepLayout
      backgroundColor={leadForm.backgroundColor}
      foregroundColor={leadForm.titleColor}
      formBackgroundColor={leadForm.formBackgroundColor}
      isMobile={isMobile}
      className="py-6"
    >
      <div className="text-2xl font-semibold mb-8 text-center" onClick={(e) => bodyClick(e)}>
        {t("extra_step_title")}
      </div>
      <div className={`flex gap-6 ${isMobile ? "flex-col" : "flex-row"}`} onClick={(e) => bodyClick(e)}>
        <div className={`flex flex-col gap-6 ${isMobile ? "w-1/1" : "w-1/2"}`}>
          <Group
            title={t("passport")}
            error={lead.errors.passport}
            field_name="passport"
            value={lead.passport}
            required={required}
            onChange={onChange}
            borderColor={leadForm.inputBorderColor}
            setActiveElement={setActiveElement}
          />
          <Group
            title={t("financing")}
            error={lead.errors.requireFinancing}
            field_name="requireFinancing"
            value={lead.requireFinancing}
            required={required}
            onChange={onChange}
            borderColor={leadForm.inputBorderColor}
            setActiveElement={setActiveElement}
          />
          <div className={`mt-auto mr-auto ${isMobile ? "hidden" : "block"}`}>
            <PoweredBy backgroundColor={leadForm.formBackgroundColor} />
          </div>
        </div>
        <div className={`flex flex-col gap-6 ${isMobile ? "w-1/1" : "w-1/2"}`}>
          {leadForm.showCustomQuestion && leadForm.customQuestion && (
            <Group
              title={leadForm.customQuestion}
              error={lead.errors.customQuestion}
              field_name="customQuestionAnswer"
              value={lead.customQuestionAnswer}
              required={required}
              onChange={onChange}
              borderColor={leadForm.inputBorderColor}
              setActiveElement={setActiveElement}
            />
          )}
          {leadForm.showWeightAndHeight && (
            <div className="w-full">
              <label className="block text-sm font-normal mb-2 ml-1">
                {t("weight_and_height")}
                {`${required ? "*" : ""}`}
              </label>
              <div className="flex w-full gap-4">
                {useMetricSystem ? (
                  <SimpleInput
                    placeholder={t("height")}
                    className="w-1/2 my-0"
                    inputType="number"
                    error={lead.errors.height}
                    field_name="height"
                    value={lead.height}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="text"
                    borderColor={leadForm.inputBorderColor}
                    Trailing="cm"
                    setActiveElement={setActiveElement}
                  />
                ) : (
                  <HeightPicker
                    label={t("height")}
                    className="w-1/2 my-0"
                    error={lead.errors.height}
                    field_name="height"
                    value={lead.height}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="text"
                    borderColor={leadForm.inputBorderColor}
                    activeElement={activeElement}
                    setActiveElement={setActiveElement}
                  />
                )}
                {useMetricSystem ? (
                  <SimpleInput
                    placeholder={t("weight")}
                    className="w-1/2 my-0"
                    inputType="number"
                    error={lead.errors.weight}
                    field_name="weight"
                    value={lead.weight}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="text"
                    borderColor={leadForm.inputBorderColor}
                    Trailing="kg"
                    setActiveElement={setActiveElement}
                  />
                ) : (
                  <SimpleInput
                    placeholder={t("weight")}
                    className="w-1/2 my-0"
                    inputType="number"
                    error={lead.errors.weight}
                    field_name="weight"
                    value={lead.weight}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="text"
                    borderColor={leadForm.inputBorderColor}
                    Trailing="lbs"
                    setActiveElement={setActiveElement}
                  />
                )}
              </div>
            </div>
          )}
          <Dropdown
            position="auto"
            title={t("how_soon")}
            error={lead.errors.howSoon}
            field_name="howSoon"
            value={lead.howSoon}
            required={required}
            onChange={onChange}
            onBlur={onBlur}
            label={t("please_select")}
            values={additionalQuestions}
            borderColor={leadForm.inputBorderColor}
            showTitle={true}
            activeElement={activeElement}
            setActiveElement={setActiveElement}
          />
          <Button
            title={t("submit")}
            backgroundColor={leadForm.submitBackgroundColor}
            color={leadForm.submitColor}
            active={step2Valid && !submitting}
            onClick={submitStep2}
          />
        </div>
        <div
          className={`w-full flex justify-center ${isMobile ? "" : "hidden"}`}
        >
          <PoweredBy backgroundColor={leadForm.formBackgroundColor} />
        </div>
      </div>
    </MultiStepLayout>
  );
}

export default Step2;
